export const ACTIVITY_INCLUDE_OPTIONS = [
  'Company', 'Partner', 'User', 'UserPartner', 'ActivityType',
] as const;
export type ActivityIncludeOption = typeof ACTIVITY_INCLUDE_OPTIONS[number];

export const ANALYTIC_OPERATION_INCLUDE_OPTIONS = [
  'Currency', 'CurrencyExchanges', 'PurchaseOrder', 'PurchaseOrderPdfPartners',
  'PurchaseOrderTransmitter', 'PurchaseOrderApprover', 'PurchaseOrderCurrency',
  'PurchaseOrderCurrencyExchanges', 'PurchaseOrderAnalyticOperations',
  'PurchaseOrderAnalyticOperationsServiceOrder',
  'PurchaseOrderAnalyticOperationsCurrency',
  'PurchaseOrderAnalyticOperationsCurrencyExchanges', 'InvoiceOrder',
  'InvoiceOrderPdfPartners', 'InvoiceOrderTransmitter', 'InvoiceOrderApprover',
  'InvoiceOrderCurrency', 'InvoiceOrderCurrencyExchanges',
  'InvoiceOrderAnalyticOperations', 'InvoiceOrderAnalyticOperationsServiceOrder',
  'InvoiceOrderAnalyticOperationsCurrency',
  'InvoiceOrderAnalyticOperationsCurrencyExchanges', 'ServiceOrder',
  'Repercussion',
] as const;
export type AnalyticOperationIncludeOption =
  typeof ANALYTIC_OPERATION_INCLUDE_OPTIONS[number];

export const BUDGET_LINE_INCLUDE_OPTIONS = [
  'Product', 'Supplier', 'Currency', 'UnitOfMeasure', 'AssociatedSaleLine',
  'Source', 'Destination', 'Taxes', 'TaxDetails', 'SaleOrder', 'SaleOrderLead',
] as const;
export type BudgetLineIncludeOption = typeof BUDGET_LINE_INCLUDE_OPTIONS[number];

export const EQUIPMENT_INCLUDE_OPTIONS = [
  'Owner', 'Contact', 'EquipmentType', 'Documents', 'Services', 'ServiceOrders',
] as const;
export type EquipmentIncludeOption = typeof EQUIPMENT_INCLUDE_OPTIONS[number];

export const EQUIPMENT_SERVICE_INCLUDE_OPTIONS = [
  'Equipment', 'EquipmentOwner', 'EquipmentContact', 'Service', 'ServiceOrders',
  'ServiceEquipments', 'ServiceEquipmentOwner', 'ServiceEquipmentContact',
] as const;
export type EquipmentServiceIncludeOption =
  typeof EQUIPMENT_SERVICE_INCLUDE_OPTIONS[number];

export const LEAD_INCLUDE_OPTIONS = [
  'Partner', 'User', 'UserPartner', 'Team', 'Stage', 'LostReason', 'Country',
  'State', 'Company', 'PartnerParent', 'CompanyCurrency', 'CostCenter', 'Currency',
  'IntermediaryCompany', 'ReferencedBy', 'Tags', 'Projects', 'SaleOrders',
  'Documents', 'Chat', 'ChatMessages',
] as const;
export type LeadIncludeOption = typeof LEAD_INCLUDE_OPTIONS[number];
export type OpportunityIncludeOption = LeadIncludeOption;

export const PARTNER_INCLUDE_OPTIONS = [
  'Parent', 'Documents', 'ChildrenParent', 'Country', 'Currency', 'State',
  'PartnerType', 'Chat', 'EquipmentsOwned', 'EquipmentsIsContact',
] as const;
export type PartnerIncludeOption = typeof PARTNER_INCLUDE_OPTIONS[number];

export const PRODUCT_INCLUDE_OPTIONS = [
  'Company', 'CompanyCurrency', 'UnitOfMeasure', 'UnitOfMeasureCategory',
  'Taxes', 'SupplierTaxes',
] as const;
export type ProductIncludeOption = typeof PRODUCT_INCLUDE_OPTIONS[number];

export const PROJECT_CONTAINER_INCLUDE_OPTIONS = [
  'ContainerType', 'Project', 'ServiceOrders',
] as const;
export type ProjectContainerIncludeOption =
  typeof PROJECT_CONTAINER_INCLUDE_OPTIONS[number];

export const PROJECT_INCLUDE_OPTIONS = [
  'Company', 'Chat', 'Lead', 'Services', 'ServiceOrders', 'ServiceShipper',
  'ServiceSupplier', 'ServiceConsignee', 'ServiceOriginContact',
  'ServiceDestinationContact', 'ServiceForwarder', 'ServiceOrigin',
  'ServiceDestination', 'OperationExecutive', 'DeputyProjectManager',
  'AdministrationAgent', 'CommercialExecutive', 'OperationsManager', 'Partner',
  'Documents', 'ProjectContainers',
] as const;
export type ProjectIncludeOption = typeof PROJECT_INCLUDE_OPTIONS[number];

export const SALE_ORDER_INCLUDE_OPTIONS = [
  'Lead', 'Partner', 'Team', 'Chat', 'Currency', 'BudgetLines', 'OrderLines',
  'Documents', 'LeadPartner', 'LeadCompany', 'LeadUser', 'LeadUserPartner',
  'PartnerParent', 'LeadPartnerParent', 'LeadTeam', 'LeadTeamManager', 'LeadTeamManagerPartner', 'ChatMessages',
  'BudgetLineTaxes', 'OrderLineTaxes',
] as const;
export type SaleOrderIncludeOption = typeof SALE_ORDER_INCLUDE_OPTIONS[number];

export const SALE_ORDER_LINE_INCLUDE_OPTIONS = [
  'Product', 'UnitOfMeasure', 'Currency', 'BudgetLine', 'Source', 'Destination',
  'Taxes', 'TaxDetails', 'SaleOrder', 'SaleOrderLead', 'BudgetLineProduct',
] as const;
export type SaleOrderLineIncludeOption =
  typeof SALE_ORDER_LINE_INCLUDE_OPTIONS[number];

export const SERVICE_INCLUDE_OPTIONS = [
  'Equipments', 'EquipmentOwner', 'EquipmentContact', 'ServiceOrders',
  'ServiceOrderDestination', 'ServiceOrderService', 'ServiceOrderServiceProject',
  'ServiceOrderServiceProjectPartner', 'ServiceOrderServiceSupplier',
  'ServiceOrderServiceForwarder', 'ServiceOrderServiceShipper',
  'ServiceOrderServiceConsignee', 'Supplier', 'Forwarder', 'Shipper',
  'Consignee', 'OriginContact', 'DestinationContact', 'Origin', 'Destination',
  'ServicePricing', 'ServicePricingCurrency', 'Project', 'ProjectPartner',
  'TransportType', 'Type', 'Chat', 'Documents', 'ServiceGoods', 'Company',
] as const;
export type ServiceIncludeOption = typeof SERVICE_INCLUDE_OPTIONS[number];

export const SERVICE_ORDER_INCLUDE_OPTIONS = [
  'Events', 'Service', 'Equipments', 'AnalyticOperations', 'AssignedTo',
  'CostCenter', 'ProjectContainer', 'LoadUnit', 'EventTypeEventClass',
  'EventTypeEventTriggers', 'ServiceProjectPartner',
  'ServiceFlowEventTypeTriggers', 'ServiceSupplier', 'ServiceConsignee',
  'ServiceShipper', 'ServiceTypeFlow', 'EquipmentType', 'EquipmentOwner',
  'EquipmentContact', 'AnalyticOperationInvoiceOrder',
  'AnalyticOperationPurchaseOrder', 'AnalyticOperationInvoiceOrderPdfPartners',
  'AnalyticOperationPurchaseOrderPdfPartners', 'AssignedToPartner',
  'CostCenterCurrency', 'ProjectContainerContainerType',
] as const;
export type ServiceOrderIncludeOption =
  typeof SERVICE_ORDER_INCLUDE_OPTIONS[number];
